/* AvemPiese Vitrina — comportamentul paginii: mărimea textului, căutare pe loc, coș fără reîncărcare,
   galeria produsului, catalogul („Arată mai multe”, filtre) și butoanele de WhatsApp. */
(function () {
  'use strict';
  var C = window.AP_CFG || {};
  var T = C.t || {};
  var R = C.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- pictograme folosite din JavaScript ---------- */
  var IP = {
    plus: '<path d="M24 10v28M10 24h28"/>',
    check: '<path d="M10 25l9 9 19-20"/>',
    box: '<path d="M6 15l18-9 18 9v18l-18 9-18-9z"/><path d="M6 15l18 9 18-9M24 24v18"/>',
    left: '<path d="M29 10L15 24l14 14"/>',
    right: '<path d="M19 10l14 14-14 14"/>',
    chat: '<path d="M24 6C14 6 6 13.4 6 22.5c0 5 2.5 9.5 6.4 12.5L11 42l8.5-4.2c1.5.4 3 .6 4.5.6 10 0 18-7.4 18-16.5S34 6 24 6z"/><path d="M16 23h.01M24 23h.01M32 23h.01" stroke-width="4.2"/>'
  };
  var icon = function (k, cls) { return '<svg class="ic ' + (cls || '') + '" viewBox="0 0 48 48" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">' + (IP[k] || IP.box) + '</svg>'; };

  /* ---------- formatare ---------- */
  function money(cents) {
    var v = (+cents || 0) / 100;
    var num = function (n, dec, ts, ds) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    };
    var fmt = C.money || '{{amount_with_comma_separator}} lei';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      var s;
      switch (k) {
        case 'amount_no_decimals': s = num(v, 0, ',', '.'); break;
        case 'amount_with_comma_separator': s = num(v, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': s = num(v, 0, '.', ','); break;
        case 'amount_with_space_separator': s = num(v, 2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': s = num(v, 2, ' ', '.'); break;
        case 'amount_with_apostrophe_separator': s = num(v, 2, "'", '.'); break;
        default: s = num(v, 2, ',', '.');
      }
      return s.replace(/[.,]00$/, '');
    }).replace(/<[^>]*>/g, '');
  }
  function plural(n, one, many) {
    if (n === 1) return '1 ' + one;
    var r = n % 100;
    return n + ' ' + ((n >= 20 && (r === 0 || r >= 20)) ? 'de ' : '') + many;
  }
  function waUrl(text) { return 'https://wa.me/' + (C.wa || '') + (text ? '?text=' + encodeURIComponent(text) : ''); }

  /* ---------- pozele apar lin, după ce s-au încărcat (vezi .card .pic în CSS) ---------- */
  function markImg(i) { if (i && i.tagName === 'IMG') i.classList.add('ld'); }
  $$('img').forEach(function (i) { if (i.complete) markImg(i); });
  document.addEventListener('load', function (e) { markImg(e.target); }, true);
  document.addEventListener('error', function (e) { markImg(e.target); }, true);

  /* ---------- mesaj jos („Am adăugat în coș”) ---------- */
  var toastT;
  function toast(msg, bad) {
    var el = $('#toast'); if (!el) return;
    $('[data-toast-msg]', el).textContent = msg;
    el.classList.toggle('bad', !!bad);
    el.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.hidden = true; }, bad ? 4500 : 3400);
  }

  /* ---------- mărimea textului ---------- */
  var SIZES = C.sizes || [1, 1.18, 1.36];
  var tsLabel = $('[data-ts-label]');
  var tsDefault = tsLabel ? tsLabel.textContent : '';
  function setSize(i, save) {
    i = Math.min(2, Math.max(0, +i || 0));
    var d = document.documentElement;
    d.style.setProperty('--ts', SIZES[i]);
    d.dataset.text = String(i);
    if (save) store.set('ap-text', String(i));
    $$('[data-size]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.size === i)); });
    if (tsLabel) tsLabel.textContent = i ? (T.textLabel || 'Text %S%').replace('%S%', ((T.sizeNames || [])[i] || '').toLowerCase()) : tsDefault;
    var btn = $('[data-act="sizes"]');
    if (btn) btn.setAttribute('aria-label', (T.textBigger || '') + ': ' + ((T.sizeNames || [])[i] || ''));
    setTimeout(fitTags, 60);
  }
  setSize(+document.documentElement.dataset.text || 0, false);

  /* ---------- „PIESE ELECTROCASNICE” cât lățimea textului din logo ---------- */
  function fitTags() {
    $$('.btag').forEach(function (t) {
      var ref = t.parentElement && t.parentElement.querySelector('.lw, img');
      if (!ref || !ref.getBoundingClientRect().width) return;
      t.style.letterSpacing = '0px'; t.style.width = 'max-content';
      var nat = t.getBoundingClientRect().width, n = t.textContent.length;
      t.style.width = '';
      t.style.letterSpacing = Math.max(0, (ref.getBoundingClientRect().width - nat) / Math.max(1, n - 1)).toFixed(2) + 'px';
    });
  }
  fitTags();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTags);
  var rsT; addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(fitTags, 150); });

  /* ---------- lista de produse pentru căutarea inteligentă ---------- */
  var Idx = {
    p: null,
    load: function () {
      if (this.p) return this.p;
      if (!C.smart || !window.APSearch) return Promise.reject(new Error('off'));
      var self = this;
      this.p = (async function () {
        var key = 'ap-idx', items = null;
        try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && c.v === C.idxVer) items = c.items; } catch (e) {}
        if (!items) {
          var get = function (pg) {
            return fetch(R.all + '?view=idx&page=' + pg, { credentials: 'same-origin' }).then(function (r) {
              if (!r.ok) throw new Error('idx'); return r.text();
            }).then(function (t) { return JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); });
          };
          var first = await get(1);
          items = first.items || [];
          var rest = [];
          for (var pg = 2; pg <= (first.pages || 1); pg++) rest.push(get(pg));
          (await Promise.all(rest)).forEach(function (r) { items = items.concat(r.items || []); });
          try { sessionStorage.setItem(key, JSON.stringify({ v: C.idxVer, items: items })); } catch (e) {}
        }
        var extra = {};
        Object.keys(C.apps || {}).forEach(function (k) { extra[k] = { label: C.apps[k].label, syn: '' }; });
        return window.APSearch.buildIndex(items, extra);
      })();
      this.p.catch(function () { self.p = null; });
      return this.p;
    }
  };
  var find = function (idx, q) { return window.APSearch.search(idx, q); };

  /* ---------- căsuțele de căutare cu rezultate pe loc ---------- */
  function dropItem(p) {
    var img = p.m ? '<img src="' + esc(p.m) + '" alt="" loading="lazy" decoding="async">' : '<span class="ph">' + icon('box') + '</span>';
    return '<a href="' + esc(p.u) + '">' + img + '<span class="n">' + esc(p.n) + '</span><span class="pr">' + (p.p ? money(p.p) : '') + '</span></a>';
  }
  function searchUrl(q) { return R.search + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
  async function suggestFallback(q) {
    var r = await fetch(R.suggest + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last');
    var j = await r.json();
    var list = ((j.resources || {}).results || {}).products || [];
    return list.map(function (p) {
      return { u: p.url, n: p.title, p: Math.round(parseFloat(p.price || 0) * 100), m: p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : (p.image || '') };
    });
  }
  function bindSearch(form) {
    if (form.__ap) return; form.__ap = true;
    var input = $('input[type=search]', form), drop = $('.drop', form);
    if (!input || !drop) return;
    var t, seq = 0;
    var close = function () { drop.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    input.setAttribute('aria-autocomplete', 'list');
    input.addEventListener('focus', function () { if (C.smart) Idx.load().catch(function () {}); }, { once: true });
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(async function () {
        var q = input.value.trim(), my = ++seq;
        if (!q) { close(); return; }
        var list, total;
        try {
          var idx = await Idx.load();
          var r = find(idx, q); list = r.list.slice(0, 6); total = r.list.length;
        } catch (e) {
          try { list = await suggestFallback(q); total = list.length; } catch (e2) { list = []; total = 0; }
        }
        if (my !== seq) return;
        drop.innerHTML = list.length
          ? list.map(dropItem).join('') + '<a class="all" href="' + esc(searchUrl(q)) + '">' + esc((T.seeAll || '%N%').replace('%N%', total)) + '</a>'
          : '<span class="none">' + esc(T.none || '') + '</span>';
        drop.hidden = false; input.setAttribute('aria-expanded', 'true');
      }, 110);
    });
    input.addEventListener('keydown', function (e) {
      if (drop.hidden) return;
      var items = $$('a', drop), cur = items.indexOf($('a.on', drop));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var n = e.key === 'ArrowDown' ? Math.min(items.length - 1, cur + 1) : Math.max(-1, cur - 1);
        items.forEach(function (a, i) { a.classList.toggle('on', i === n); });
        if (items[n]) items[n].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && cur > -1) { e.preventDefault(); location.href = items[cur].href; }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }
  $$('form[data-sform]').forEach(bindSearch);

  /* ---------- meniul lateral (pe telefon) ---------- */
  var mnav = $('#mnav'), mnavT, mnavFrom = null;
  function openMenu() {
    if (!mnav) return;
    clearTimeout(mnavT);
    mnavFrom = document.activeElement;
    mnav.hidden = false;
    document.body.classList.add('menu-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { mnav.classList.add('open'); }); });
    $$('[data-act="menu"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var x = $('.mnav-top [data-act="menu-close"]', mnav); if (x) x.focus({ preventScroll: true });
  }
  function closeMenu(noFocus) {
    if (!mnav || mnav.hidden) return;
    mnav.classList.remove('open');
    document.body.classList.remove('menu-open');
    $$('[data-act="menu"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    mnavT = setTimeout(function () { mnav.hidden = true; }, RM ? 0 : 320);
    if (!noFocus && mnavFrom && mnavFrom.focus) mnavFrom.focus({ preventScroll: true });
  }
  if (mnav) {
    var panel = $('.mnav-in', mnav), sx = 0, sy = 0, swiping = false;
    panel.addEventListener('touchstart', function (e) { var p = e.touches[0]; sx = p.clientX; sy = p.clientY; swiping = true; }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (!swiping) return;
      var p = e.touches[0], dx = p.clientX - sx, dy = p.clientY - sy;
      if (Math.abs(dy) > 40) { swiping = false; return; }
      if (dx > 70) { swiping = false; closeMenu(true); }
    }, { passive: true });
    addEventListener('resize', function () { if (innerWidth > 760) closeMenu(true); });
  }

  /* ---------- căutare peste tot ---------- */
  var spot = $('#spot');
  function openSpot() {
    if (!spot) return;
    spot.hidden = false;
    var i = $('input[type=search]', spot); if (i) { i.focus(); i.select(); }
  }
  function closeSpot() { if (spot) spot.hidden = true; }
  if (spot) spot.addEventListener('click', function (e) { if (e.target === spot) closeSpot(); });

  /* ---------- coș ---------- */
  var Cart = {
    ids: new Set(((C.cart || {}).ids) || []),
    count: (C.cart || {}).count || 0,
    paint: function () {
      var n = this.count;
      $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
      var bag = $('#bagBtn'); if (bag) bag.setAttribute('aria-label', n ? (T.cartLabel || '') + ', ' + n : (T.cartLabel || ''));
      var ids = this.ids;
      $$('[data-add]').forEach(function (b) {
        var inC = ids.has(+b.dataset.add);
        if (b.classList.contains('in') === inC) return;
        b.classList.toggle('in', inC);
        b.innerHTML = icon(inC ? 'check' : 'plus') + '<span>' + esc(inC ? T.inCart : (T.add || (C.card || {}).add)) + '</span>';
      });
    },
    refresh: function () {
      var self = this;
      return fetch(R.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        self.count = c.item_count; self.ids = new Set(c.items.map(function (i) { return i.variant_id; })); self.paint(); return c;
      });
    }
  };
  async function addToCart(id, qty, btn) {
    qty = Math.max(1, +qty || 1);
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      var r = await fetch(R.cartAdd + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: +id, quantity: qty }] })
      });
      var j = await r.json().catch(function () { return {}; });
      if (!r.ok) throw new Error(j.description || j.message || T.addError);
      await Cart.refresh();
      toast(qty > 1 ? (T.addedN || '').replace('%N%', qty) : T.added);
    } catch (e) {
      toast((e && e.message) || T.addError, true);
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  }
  addEventListener('pageshow', function (e) {
    if (e.persisted) {
      Cart.refresh().catch(function () {});
      closeMenu(true);
      $$('[data-checkout][aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
    }
  });

  /* ---------- „Finalizează comanda”: piesa în coș (cu cantitatea aleasă), apoi direct la plată ---------- */
  async function goCheckout(id, qty, btn) {
    id = +id; qty = Math.max(1, +qty || 1);
    if (btn) btn.setAttribute('aria-busy', 'true');
    try {
      var r;
      if (Cart.ids.has(id)) {
        var up = {}; up[id] = qty;
        r = await fetch(R.cart + '/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: up })
        });
      } else {
        r = await fetch(R.cartAdd + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        });
      }
      if (!r.ok) { var j = await r.json().catch(function () { return {}; }); throw new Error(j.description || j.message || T.checkoutError); }
      location.href = R.checkout || '/checkout';
    } catch (e) {
      if (btn) btn.removeAttribute('aria-busy');
      toast((e && e.message) || T.checkoutError || T.addError, true);
    }
  }

  /* ---------- cardul de produs desenat din JavaScript (rezultatele căutării) ---------- */
  function cardHTML(p) {
    var inC = Cart.ids.has(p.i);
    var sale = p.o > p.p ? Math.round((1 - p.p / p.o) * 100) : 0;
    var tag = sale ? (T.sale || '%N%').replace('%N%', sale) : ((C.card || {}).stock && p.s ? T.inStock : '');
    var img = p.m ? '<img src="' + esc(p.m.replace(/([?&])width=\d+/, '$1width=400')) + '" alt="' + esc(p.n) + '" loading="lazy" decoding="async">' : icon('box', 'ph');
    var btn = p.s && p.p
      ? '<button class="addb' + (inC ? ' in' : '') + '" type="button" data-add="' + p.i + '">' + icon(inC ? 'check' : 'plus') + '<span>' + esc(inC ? T.inCart : T.add) + '</span></button>'
      : '<a class="addb" href="' + esc(waUrl((C.msg.ask || '').replace('{produs}', p.n).replace('{cod}', p.c))) + '" target="_blank" rel="noopener">' + icon('chat') + '<span>' + esc(T.askPrice || '') + '</span></a>';
    return '<article class="card"><a class="cover" href="' + esc(p.u) + '" aria-label="' + esc(p.n) + '"></a>' +
      '<div class="pic">' + img + '</div><div class="tag' + (!sale && tag ? ' ok' : '') + '">' + esc(tag) + '</div><h3 class="nm">' + esc(p.n) + '</h3>' +
      ((C.card || {}).code && p.c ? '<div class="cd mono">' + esc(T.code) + ' ' + esc(p.c) + '</div>' : '') +
      '<div class="row"><span class="price">' + (p.p ? money(p.p) + (sale ? '<s class="old">' + money(p.o) + '</s>' : '') : esc(T.onRequest || '')) + '</span>' + btn + '</div></article>';
  }

  /* ---------- pagina de căutare: rezultatele căutării inteligente ---------- */
  var sp = $('[data-search-page]');
  if (sp && sp.dataset.q && C.smart) {
    Idx.load().then(function (idx) {
      var q = sp.dataset.q, r = find(idx, q), list = r.list, per = +sp.dataset.perPage || 24, shown = 0;
      var box = $('[data-search-results]', sp), cnt = $('[data-search-count]', sp);
      var serverHas = !!$('.grid', box);
      if (!list.length) {
        if (serverHas) return;
        var tpl = $('[data-empty-tpl]', sp);
        if (tpl) {
          box.innerHTML = tpl.innerHTML;
          var b = $('[data-wa-search-btn]', box); if (b) b.href = waUrl((C.msg.search || '').replace('{cautare}', q));
        }
        return;
      }
      if (cnt) cnt.textContent = plural(list.length, T.foundOne, T.found) + (r.partial ? ' · ' + T.near : '');
      box.innerHTML = '<div class="grid" data-grid></div><div class="more" hidden><button class="btn sec" type="button" data-jsmore></button></div>';
      var grid = $('.grid', box), more = $('.more', box), mb = $('[data-jsmore]', box);
      var page = function () {
        grid.insertAdjacentHTML('beforeend', list.slice(shown, shown + per).map(cardHTML).join(''));
        shown += per;
        var left = list.length - shown;
        more.hidden = left <= 0;
        if (left > 0) mb.textContent = (T.more || '%N%').replace('%N%', plural(Math.min(per, left), T.piece, T.pieces));
      };
      mb.addEventListener('click', page);
      page();
      if (r.intent) { var chip = $('[data-app-chip="' + r.intent + '"]', sp); if (chip) chip.setAttribute('aria-pressed', 'true'); centerChip(chip && chip.parentElement); }
    }).catch(function () {});
  }

  /* ---------- rândurile de butoane: cel ales rămâne la mijloc ---------- */
  function centerChip(row, smooth) {
    if (!row) return;
    var b = $('[aria-pressed="true"]', row);
    if (!b || row.scrollWidth <= row.clientWidth + 1) return;
    var left = row.scrollLeft + b.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - b.offsetWidth) / 2;
    row.scrollTo({ left: Math.max(0, Math.min(left, row.scrollWidth - row.clientWidth)), behavior: smooth && !RM ? 'smooth' : 'auto' });
  }
  /* ---------- rândurile care se derulează în lateral: săgeți stânga / dreapta pe calculator ----------
     Pe telefon se derulează cu degetul; cu mouse-ul nu se poate, așa că apar două săgeți mici
     (doar când chiar mai e ceva de văzut în partea aceea) și marginile se estompează. */
  function sxUpd(w) {
    var el = w.firstElementChild; if (!el) return;
    var max = el.scrollWidth - el.clientWidth;
    w.classList.toggle('can-l', max > 2 && el.scrollLeft > 2);
    w.classList.toggle('can-r', max > 2 && el.scrollLeft < max - 2);
  }
  function sxInit(root) {
    $$('[data-scrollx]', root).forEach(function (el) {
      if (el.matches('.gal') || (el.parentElement && el.parentElement.classList.contains('sx'))) return;
      var w = document.createElement('div');
      w.className = 'sx';
      el.parentNode.insertBefore(w, el);
      w.appendChild(el);
      ['prev', 'next'].forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'sx-btn sx-' + d; b.tabIndex = -1;
        b.setAttribute('aria-hidden', 'true'); b.dataset.sx = d === 'prev' ? '-1' : '1';
        b.innerHTML = icon(d === 'prev' ? 'left' : 'right');
        w.appendChild(b);
      });
      el.addEventListener('scroll', function () { sxUpd(w); }, { passive: true });
      sxUpd(w);
    });
  }
  function sxAll() { $$('.sx').forEach(sxUpd); }
  sxInit();
  $$('.appchips, .cath .parts').forEach(function (r) { centerChip(r, false); });
  sxAll();
  addEventListener('resize', function () { clearTimeout(sxAll.t); sxAll.t = setTimeout(sxAll, 120); });
  addEventListener('load', sxAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sxAll);

  /* ---------- catalog: numărul de piese pe tipuri ---------- */
  function countTypes() {
    var col = $('[data-collection]');
    if (!col || !col.dataset.app || !$('.cath .parts [data-type]') || !C.smart) return;
    Idx.load().then(function (idx) {
      var app = col.dataset.app, counts = {};
      idx.products.forEach(function (p) { if (p.a === app) counts[p.t] = (counts[p.t] || 0) + 1; });
      $$('.cath .parts [data-type]').forEach(function (a) { var n = counts[a.dataset.type]; var s = $('[data-count]', a); if (s && n) s.textContent = n; });
    }).catch(function () {});
  }
  countTypes();

  /* ---------- catalog: altă categorie / alt tip / altă marcă fără reîncărcarea paginii ----------
     Pagina nouă se cere din timp (la atingere sau la trecerea cu mouse-ul), primele poze se încarcă
     înainte de schimbare, iar rândul cu aparate rămâne pe loc, cu cel ales la mijloc. */
  var catCache = {}, catSeq = 0, warmed = {};
  var conn = navigator.connection || {};
  var lite = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  function catKey(href) { var u = new URL(href, location.href); u.hash = ''; return u.toString(); }
  function isCatUrl(href) {
    try { var u = new URL(href, location.href); return u.origin === location.origin && /^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\/[^/]+/i.test(u.pathname) && u.pathname.indexOf('/products/') < 0; }
    catch (e) { return false; }
  }
  function catFetch(href) {
    var key = catKey(href), cur = $('[data-collection]');
    if (!cur || !cur.dataset.section) return Promise.reject(new Error('nocol'));
    if (!catCache[key]) {
      var u = new URL(key); u.searchParams.set('section_id', cur.dataset.section);
      catCache[key] = fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status); return r.text();
      });
      catCache[key].catch(function () { delete catCache[key]; });
    }
    return catCache[key];
  }
  function warmImgs(root, n, ms) {
    var ps = $$('.cath img, .card .pic img', root).slice(0, n).map(function (im) {
      return new Promise(function (res) {
        var i = new Image();
        if (im.getAttribute('sizes')) i.sizes = im.getAttribute('sizes');
        if (im.getAttribute('srcset')) i.srcset = im.getAttribute('srcset');
        i.onload = i.onerror = function () { res(); };
        i.src = im.getAttribute('src');
        if (i.complete) res();
      });
    });
    var all = Promise.all(ps);
    return ms ? Promise.race([all, new Promise(function (r) { setTimeout(r, ms); })]) : all;
  }
  function catPrefetch(href, imgs) {
    if (!isCatUrl(href) || !$('[data-collection]')) return;
    var key = catKey(href), p = catFetch(href);
    if (imgs && !warmed[key]) {
      warmed[key] = 1;
      p.then(function (html) { warmImgs(new DOMParser().parseFromString(html, 'text/html'), 4); }).catch(function () {});
    }
  }
  /* la răgaz: celelalte categorii se cer dinainte (sunt mici, câțiva KB fiecare), iar pentru vecinele
     celei alese se încarcă și primele poze, ca trecerea la ele să fie instantă */
  function catPrefetchNear() {
    if (lite) return;
    var row = $('[data-catrow]') || $('.appchips'); if (!row) return;
    var links = $$('a', row), i = -1;
    links.forEach(function (a, k) { if (a.getAttribute('aria-pressed') === 'true') i = k; });
    var near = [], rest = [];
    links.forEach(function (a, k) { if (k === i) return; (Math.abs(k - i) <= 1 ? near : rest).push(a); });
    var go = function () {
      near.forEach(function (a) { catPrefetch(a.href, true); });
      rest.forEach(function (a, k) { setTimeout(function () { catPrefetch(a.href, false); }, 250 * (k + 1)); });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200);
  }
  function syncRow(row, newRow, href) {
    if (!row) return;
    var want = '';
    if (newRow) { var pr = $('[aria-pressed="true"]', newRow); want = pr ? pr.getAttribute('href') : ''; }
    else { try { want = new URL(href, location.href).pathname; } catch (e) {} }
    $$('a', row).forEach(function (a) { a.setAttribute('aria-pressed', String(a.getAttribute('href') === want)); });
  }
  var lastCat = location.pathname + location.search;
  async function catNav(href, opts) {
    opts = opts || {};
    var cur = $('[data-collection]');
    if (!cur || !isCatUrl(href)) { location.href = href; return; }
    var my = ++catSeq;
    var row = $('[data-catrow]');
    cur.setAttribute('aria-busy', 'true');
    try {
      var html = await catFetch(href);
      if (my !== catSeq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nc = $('[data-collection]', doc);
      if (!nc) throw new Error('nocol');
      await warmImgs(nc, 6, 380);
      if (my !== catSeq) return;
      var sameCat = nc.dataset.app === cur.dataset.app && ($('h1', nc) || {}).textContent === ($('h1', cur) || {}).textContent;
      /* aceeași categorie (alt tip / altă marcă / altă ordine): poza și rândul cu tipuri rămân unde erau */
      var oimg = $('.cath img', cur), nimg = $('.cath img', nc);
      if (oimg && nimg && oimg.getAttribute('src') === nimg.getAttribute('src')) nimg.replaceWith(oimg);
      var oparts = $('.cath .parts', cur), partsX = sameCat && oparts ? oparts.scrollLeft : 0;
      syncRow(row, $('[data-catrow]', doc), href);
      nc.classList.add('swapped');
      if (!sameCat) nc.classList.add('newcat');
      var y = scrollY;
      cur.replaceWith(nc);
      sxInit(nc);
      var nparts = $('.cath .parts', nc);
      if (nparts) { nparts.scrollLeft = partsX; centerChip(nparts, sameCat); }
      if (opts.pop) scrollTo(0, opts.y || 0);
      else if (Math.abs(scrollY - y) > 1) scrollTo(0, y);
      if (!opts.pop) {
        try { history.replaceState(Object.assign({}, history.state || {}, { y: y }), ''); } catch (e) {}
        history.pushState({ cat: 1, y: scrollY }, '', href);
      }
      lastCat = location.pathname + location.search;
      var h1 = $('h1', nc);
      if (h1) document.title = h1.textContent.trim() + ' – ' + document.title.split(' – ').pop();
      centerChip(row, true);
      sxAll();
      $$('form[data-sform]', nc).forEach(bindSearch);
      $$('img', nc).forEach(function (i) { if (i.complete) markImg(i); });
      countTypes();
      Cart.paint();
      catPrefetchNear();
    } catch (e) {
      if (my === catSeq) location.href = href;
    }
  }
  addEventListener('popstate', function (e) {
    var now = location.pathname + location.search;
    if (now === lastCat) return;
    if ($('[data-collection]') && isCatUrl(location.href)) {
      catNav(location.href, { pop: true, y: e.state && typeof e.state.y === 'number' ? e.state.y : 0 });
    } else { lastCat = now; }
  });
  if (!lite) {
    var pfT;
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      var a = e.target.closest && e.target.closest('.appchips a, .cath .parts a');
      if (!a) return;
      clearTimeout(pfT); pfT = setTimeout(function () { catPrefetch(a.href, true); }, 70);
    }, { passive: true });
    document.addEventListener('touchstart', function (e) {
      var a = e.target.closest && e.target.closest('.appchips a, .cath .parts a');
      if (a) catPrefetch(a.href, true);
    }, { passive: true });
  }
  if ($('[data-collection]')) catPrefetchNear();

  /* ---------- „Arată mai multe” (colecții și căutare) ---------- */
  async function loadMore(a) {
    var wrap = a.closest('[data-section]'); if (!wrap) { location.href = a.href; return; }
    a.setAttribute('aria-busy', 'true');
    try {
      var u = new URL(a.href, location.href); u.searchParams.set('section_id', wrap.dataset.section);
      var html = await (await fetch(u.toString(), { credentials: 'same-origin' })).text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-grid]', wrap), ng = $('[data-grid]', doc);
      if (!grid || !ng) throw new Error('grid');
      Array.prototype.slice.call(ng.children).forEach(function (el) { grid.appendChild(el); });
      var mw = a.closest('[data-more-wrap]'), nmw = $('[data-more-wrap]', doc);
      if (nmw) mw.replaceWith(nmw); else mw.remove();
      Cart.paint();
    } catch (e) { location.href = a.href; }
  }

  /* ---------- produs: galerie, cantitate, WhatsApp ---------- */
  var gal = $('[data-gal]');
  if (gal) {
    var gt;
    gal.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () {
        var k = Math.round(gal.scrollLeft / gal.clientWidth);
        $$('[data-gimg]').forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === k)); });
        var c = $('[data-gcount]'); if (c) c.textContent = (k + 1) + ' / ' + gal.children.length;
      }, 60);
    }, { passive: true });
  }
  function updWa(form) {
    var wa = $('[data-wa-product]'); if (!wa) return;
    var q = form ? (+($('input[name=quantity]', form) || {}).value || 1) : 1;
    wa.href = waUrl((wa.dataset.tpl || '').replace('{cantitate}', q));
  }

  /* ---------- pagina coșului ---------- */
  var cartTimers = {};
  async function changeLine(line, qty) {
    var root = $('[data-cart-root]'); if (!root) return;
    var sid = root.dataset.section;
    root.setAttribute('aria-busy', 'true');
    try {
      var r = await fetch(R.cartChange + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +line, quantity: Math.max(0, qty), sections: [sid], sections_url: location.pathname })
      });
      var j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || T.error);
      var html = j.sections && j.sections[sid];
      var holder = document.getElementById('shopify-section-' + sid);
      if (html && holder) { holder.outerHTML = html; } else { location.reload(); return; }
      Cart.count = j.item_count; Cart.ids = new Set((j.items || []).map(function (i) { return i.variant_id; })); Cart.paint();
    } catch (e) {
      toast((e && e.message) || T.error, true);
      var rr = $('[data-cart-root]'); if (rr) rr.removeAttribute('aria-busy');
    }
  }
  function queueLine(line, qty) {
    clearTimeout(cartTimers[line]);
    cartTimers[line] = setTimeout(function () { changeLine(line, qty); }, 380);
  }
  var noteT;
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-cart-note]')) {
      clearTimeout(noteT);
      var v = e.target.value;
      noteT = setTimeout(function () {
        fetch(R.cart + '/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: v }) }).catch(function () {});
      }, 600);
    }
  });

  /* ---------- toate apăsările ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var sb = t.closest('button[type=submit]');
    if (sb && sb.form) sb.form.__sub = sb;

    if (mnav && t.closest('#mnav a')) { closeMenu(true); return; }

    var sxb = t.closest('[data-sx]');
    if (sxb) {
      var sxr = sxb.parentElement.firstElementChild;
      sxr.scrollBy({ left: (+sxb.dataset.sx) * Math.max(160, Math.round(sxr.clientWidth * 0.7)), behavior: RM ? 'auto' : 'smooth' });
      return;
    }

    var cl = t.closest('.appchips a, .cath .parts a');
    if (cl && $('[data-collection]') && isCatUrl(cl.href) && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.defaultPrevented) {
      e.preventDefault();
      if (catKey(cl.href) === catKey(location.href)) return;
      var inRow = !!cl.closest('.appchips');
      var was = cl.getAttribute('aria-pressed') === 'true';
      $$('a', cl.parentElement).forEach(function (a) { a.setAttribute('aria-pressed', 'false'); });
      if (inRow || !was) cl.setAttribute('aria-pressed', 'true');
      if (inRow) centerChip(cl.parentElement, true);
      catNav(cl.href, { anchor: inRow });
      return;
    }

    var add = t.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add.dataset.add, 1, add); return; }

    var q = t.closest('[data-qty]');
    if (q) {
      var box = q.closest('.qty'), inp = box && $('input', box);
      if (inp) {
        var min = +inp.min || 0, max = +inp.max || 999;
        var v = Math.min(max, Math.max(min, (+inp.value || 0) + (+q.dataset.qty)));
        if (inp.dataset.line) { if (v < 1) v = 0; inp.value = v; queueLine(inp.dataset.line, v); }
        else { inp.value = Math.max(1, v); updWa(inp.form); }
      }
      return;
    }
    var rm = t.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.remove, 0); return; }

    var gi = t.closest('[data-gimg]');
    if (gi && gal) { gal.scrollTo({ left: gal.clientWidth * +gi.dataset.gimg, behavior: RM ? 'auto' : 'smooth' }); return; }

    var more = t.closest('[data-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }

    var act = t.closest('[data-act]');
    var pop = $('#sizePop');
    if (act) {
      var a = act.dataset.act;
      if (a === 'menu') { openMenu(); return; }
      if (a === 'menu-close') { closeMenu(); return; }
      if (a === 'spot') { closeMenu(true); openSpot(); return; }
      if (a === 'spot-close') { closeSpot(); return; }
      if (a === 'sizes' && pop) {
        pop.hidden = !pop.hidden; act.setAttribute('aria-expanded', String(!pop.hidden));
        if (!pop.hidden) { var cur = $('[aria-pressed="true"]', pop); if (cur) cur.focus(); }
        return;
      }
    }
    var sz = t.closest('[data-size]');
    if (sz) { setSize(+sz.dataset.size, true); return; }
    if (pop && !pop.hidden && !t.closest('#sizePop')) { pop.hidden = true; var sb = $('[data-act="sizes"]'); if (sb) sb.setAttribute('aria-expanded', 'false'); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('select[data-nav]')) {
      var to = new URL(t.value, location.href).toString();
      if ($('[data-collection]') && isCatUrl(to)) catNav(to); else location.href = to;
      return;
    }
    if (t.matches('form[data-sort] select')) {
      var su = new URL(location.href); su.searchParams.set('sort_by', t.value); su.searchParams.delete('page');
      if ($('[data-collection]')) catNav(su.toString()); else t.form.submit();
      return;
    }
    if (t.matches('.qty input[data-line]')) { queueLine(t.dataset.line, Math.max(0, Math.round(+t.value || 0))); return; }
    if (t.matches('.qty input')) { t.value = Math.max(1, Math.min(999, Math.round(+t.value || 1))); updWa(t.form); return; }
    if (t.matches('select[data-variant]')) {
      var o = t.options[t.selectedIndex], pr = $('[data-price]'), sk = $('[data-sku]');
      if (pr && o.dataset.price) pr.textContent = o.dataset.price;
      if (sk) sk.textContent = o.dataset.sku || '';
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-product-form]')) {
      e.preventDefault();
      var id = (f.querySelector('[name=id]') || {}).value, qty = (f.querySelector('[name=quantity]') || {}).value || 1;
      var sub = e.submitter || f.__sub; f.__sub = null;
      if (sub && sub.hasAttribute('data-checkout')) { goCheckout(id, qty, sub); return; }
      addToCart(id, qty, f.querySelector('[name=add]') || f.querySelector('[type=submit]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && mnav && !mnav.hidden) {
      var fs = $$('a[href], button:not([disabled])', mnav).filter(function (el) { return el.offsetParent !== null; });
      if (fs.length) {
        var first = fs[0], last = fs[fs.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key === 'Escape') {
      closeMenu();
      closeSpot();
      var pop = $('#sizePop'); if (pop) pop.hidden = true;
    }
    if ((e.metaKey || e.ctrlKey) && (e.key || '').toLowerCase() === 'k') { e.preventDefault(); openSpot(); }
  });

  Cart.paint();
})();
